module.exports = __webpack_public_path__ + "static/flow-4a0cde7383d4593366bd5d7b0e0c0b74.png";